import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import SignIn from "views/auth/SignIn";
import { ToastContainer } from "react-toastify";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("hiedberg_admin_token");
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};
const ExistRoute = ({ children }) => {
  const token = localStorage.getItem("hiedberg_admin_token");
  if (token) {
    return <Navigate to="/admin/navbar" replace />;
  }
  return children;
};

const App = () => {
  return (
    <>
      <Routes>
        <Route
          path="admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ExistRoute>
              <SignIn />
            </ExistRoute>
          }
        />
      </Routes>
      <ToastContainer theme="colored" />
    </>
  );
};

export default App;
